import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import { WelcomeDivDevops } from './styled';

export type FormWelcomeMessageProps = {
  readonly isBundleDevops: boolean;
  readonly isLoggedIn: boolean | undefined;
  readonly welcomeMessage: any;
  readonly username: string | null;
};

export function FormWelcomeMessage({
  isBundleDevops,
  isLoggedIn,
  welcomeMessage,
  username
}: FormWelcomeMessageProps) {
  if (isBundleDevops && isLoggedIn) {
    return (
      <WelcomeDivDevops>
        <FormattedMessage
          values={{ username }}
          {...messages.devopsSignedInWelcomeMessage}
        />
      </WelcomeDivDevops>
    );
  }
  return <FormattedMessage values={{ username }} {...welcomeMessage} />;
}
